<template>
  <div class="home">

    <HelloWorld :msg="mensaje"/>
    <ThermoCompo :ThermoD="mensaje" />
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import ThermoCompo from '@/components/ThermoCompo.vue'
export default {
  name: 'home',
  data(){
    return{
      mensaje:''
    }
  },
  components: {
    HelloWorld,
    ThermoCompo
  },
  created(){
    this.mensaje ='tototototot'
  }
}
</script>
